import { useCallback, useEffect, useState } from 'react';
import { OrganisationService } from '../../services/company/organisationService';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import {ClientService} from "../../services/clients/clientService";

/*----------------------------------------------------------------------------------------
* EN: Hook to manage company fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de compañias.
----------------------------------------------------------------------------------------*/

const useClients = () => {

    // STATES

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const [filters, setFilters] = useState({
        filter_filters: {},
        limit: 999999,
    });

    // FUNCTIONS

    const fetchClients = useCallback(async (clientId?: string) => {
        try {
            if (!userCan('list', 'client')) return;
            const service = new ClientService();
            const response = await service.listClients(filters);
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                console.log('mappedData', fetchedData);
                const mappedData = fetchedData.data?.data?.map((data: { id: string; companyName: string; company?: { id: string } }) => ({
                    value: data.id,
                    label: data.companyName,
                    companyId: data.company?.id ?? '',
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching clients:', error);
        }
    }, [filters]);

    const updateHookFilters = (newFilters: any) => {
        setFilters({ 
            limit : newFilters.limit || 999999,
            filter_filters : {...filters.filter_filters, ...newFilters.filter_filters},
        });
    };

    useEffect(() => {
        fetchClients();
    }, [filters]);

    const getClientsList = () => {
        return data;
    };

    return { fetchClients, getClientsList, updateHookFilters };
}

export default useClients;